import { reducer, initialState } from './reducer'
import * as actions from './actions'

export type { CORE } from './actions'
export type { CoreSliceType } from './reducer'
export const CoreReducer = { reducer, initialState, actions }
